<template>
    <div class="d-flex w-100 mt-4">
        <div class="col-sm-12 col-md-4 offset-md-4">
            <div class="card shadow">
                <div class="card-body p-5">

                    <h2 v-if="appId && model.app.name">{{model.app.name}} Sign In</h2>
                    <h2 v-else>Sign In</h2>

                    <div v-if="errorMessage" class="alert alert-warning" role="alert">
                        {{errorMessage}}
                    </div>

                    <form class="my-1">

                        <div class="mb-3">
                            <label for="user_email">Email</label><br>
                            <input v-model="user.email" autofocus="autofocus" autocomplete="off" class="form-control"
                                   type="email" id="user_email">
                        </div>

                        <div class="mb-3">
                            <label for="user_password">Password</label><br>
                            <input v-model="user.password" autocomplete="off" class="form-control" type="password"
                                   id="user_password">
                        </div>

                        <div class="mb-3">
                            <input type="checkbox" id="user_remember_me" v-model="user.rememberMe">
                            <label for="user_remember_me">Remember me</label>
                        </div>

                        <div class="actions">
                            <button class="btn btn-primary btn-rounded btn-wide" @click.prevent="onSigninClick">Sign
                                in
                            </button>
                        </div>
                    </form>

                    <div class="mt-4">
                        <router-link :to="{ name: 'sign-up'}">
                            New here? Create a free account.
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import UserService from "./services/UserService";

    export default {
        name: 'SignIn',
        data() {
            return {
                model: webase.model,
                user: {
                    email: '',
                    password: '',
                    rememberMe: false
                },
                errorMessage: null,
                appId: null
            }
        },
        mounted() {
            if(this.$route.params.app_id) {
                this.appId = this.$route.params.app_id
                console.log('App ID: ' + this.appId)
            }
        },
        methods: {
            onSigninClick() {
                this.errorMessage = null
                let service = new UserService()
                let site = window.location.hostname
                service.login(this.user.email, this.user.password, site).then((response) => {
                    WEBASE_SYSTEM_ID = response.auth_token
                    webase.model.auth_token = WEBASE_SYSTEM_ID
                    webase.model.user_id = response.id

                    if(this.user.rememberMe) {
                        window.localStorage.setItem('WEBASE_SYSTEM_ID', webase.model.auth_token)
                    }

                    if (this.appId) {
                        this.$router.push({name: 'public-app', params: {id: this.appId} })
                    } else {
                        this.$router.push({name: 'apps'})
                    }

                }).catch((error) => {
                    this.errorMessage = 'Invalid email or password'
                })
            }
        }
    }
</script>

<style>

</style>
